/* eslint 'array-callback-return': 'off'  */
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Table, Button, FormGroup, Col } from 'reactstrap';
import { GetUserChangeLogDetails } from '../../../../action/Administration/administrationAction';
import {Redirect} from 'react-router-dom';
import { createFilter } from 'react-search-input';
import DatePicker from 'react-datepicker';
import DatePickerCustom from '../../../common/DatePicker';
import '../../../../Assets/EnsembleStyles/Administration/administration.css';
import { getAllResources } from '../../../../action/cultureAction';

const KEYS_TO_FILTERS = ['transactionTypeName', 'userName', 'affected.affectedText', 'details.detailedText','details.newValue','details.priority', 'comments', 'formattedDatetime'];
class ManageUserChangeLog extends Component {

    componentWillMount() {
        var Data = {
            "StartDate" : "1/1/0001 12:00:00 AM",
            "EndDate" : "1/1/0001 12:00:00 AM"
        }
        this.props.GetUserChangeLogDetails(Data);
    }
    componentDidMount(){
        if(this.props.getLabels["ActionsAndSettings.UAText.Text"] === undefined){
            this.props.getAllResources();
        }
    }
    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            this.setState({ UserChangelog_List: nextProps.UserChangelog_List_Response });
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            redirect: false,
            UserChangelog_List: [],
            searchTerm: '',
            startDate: null,
            endDate: null
        }
        this.BackToActionSettings = this.BackToActionSettings.bind(this);
        this.searchUpdated = this.searchUpdated.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChange2 = this.handleChange2.bind(this);
        this.datefilter = this.datefilter.bind(this);
    }

    BackToActionSettings(){
        this.setState({redirect:true});
    }

    searchUpdated(term) {
        this.setState({ searchTerm: this.refs.userChangelog_search_value.value })
    }

    handleChange(date) {
        this.setState({ startDate: date });
    }

    handleChange2(date) {
        this.setState({ endDate: date });
    }

    datefilter() {
        let fromDate, toDate, data = null;
        let FilteredData = [];
        let from = this.state.startDate;
        let to = this.state.endDate;

        if (from != null && to != null) {
            fromDate = new Date(from);
            toDate = new Date(to);
            data = this.state.UserChangelog_List;

            data.filter(function (e) {
                var aDate = new Date(e.cretedDateTime);
                if (aDate.getDate() >= fromDate.getDate() && aDate.getDate() <= toDate.getDate()) {
                    FilteredData.push(e);
                }
            });
            if (FilteredData.length !== 0) {
                return FilteredData;
            }
        }
        return;
    }

    
    render(UserChangelog_List_Response,getLabels) {
        let LogDetails = [], data, FilteredData;
        let label = this.props.getLabels

        if(this.state.redirect){
            return <Redirect to={"/SystemAdmin/Administration"} />
        } 

        data = this.state.UserChangelog_List;
        let fromDate =  this.state.startDate;
        let toDate =  this.state.endDate;
 
        if(fromDate != null && toDate != null){
            data=  this.datefilter();
        }
        if (data !== undefined && data !== null && data.length > 0) {
            FilteredData = data.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
            if (FilteredData.length !== 0) {
                LogDetails = FilteredData.map((el, index) => (
                    <tr key={index}>
                        <td>{el.transactionTypeName}</td>
                        <td>{el.userName.split("(")[0]}<br/>{"("+el.userName.split("(")[1]}</td>
                        <td>
                            <table id="tblUserLog" className="Custom_table tblWidth">
                                <tr className="LogDetailsText" style={{"height":"15px"}}>
                                    <td colSpan="5">{el.affected.affectedText}</td>
                                </tr>
                                <tr className="LogDetailsText" style={{"height":"15px"}}>
                                    <td width="40%">{el.details.detailedText}</td>
                                    <td width="15%">{el.details.oldValue}</td>
                                    <td width="15%">{el.details.newValue}</td>
                                    <td width="15%">{el.details.priority}</td>
                                    <td width="15%">{el.details.remainingTime}</td>
                                </tr>
                                <tr className="LogDetailsText">
                                    <td colSpan="5" style={{"white-space":"pre"}}>{el.comments}</td>
                                </tr>
                                <tr>
                                    <td colSpan="5" className="LogEventDatetime">{el.formattedDatetime}</td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                ));
            }else{
                LogDetails = <tr><td colSpan="3">{"No Records Found."}</td></tr>
            }
        }else{
            LogDetails = <tr><td colSpan="3">{"No Records Found."}</td></tr>
        }

        return (
            <div className="main_container">
            <h2 className="dbd_sub_heading" style={{"width":"100%"}}>{label['SystemLogs.hlnkUserChangeLog.Text'] !==undefined ? label['SystemLogs.hlnkUserChangeLog.Text'] : "User Change Log"}</h2>
            <div className="clear">&nbsp;</div>
            {/* <p className="sub_text">Use the filters and Arrange By fields to view User Change Log data.</p> */}
            <br/>
            <div className="buttons_container">
                {/* <SearchInput className="search-input" onChange={this.searchUpdated} /> */}
               
                <span className="pm_outersearchbox" style={{ float: 'right' }}>
                    <input type="text" className="pm_searchbox" style={{ paddingLeft: '10px', 'margin-top': '3px' }} placeholder="Enter Value..." onChange={this.searchUpdated} ref="userChangelog_search_value" />
                </span>
                <label style={{ fontFamily: 'lato', fontSize: '13px', fontWeight: 'bold', color: 'black', float: 'right', 'margin-top': '4px' }}>{"Search:"}</label>

                <div className="date_range_filter" style={{ width: '220px' }}>
                    <DatePicker className="Form_Datepicker date_filter"
                        customInput={<DatePickerCustom />}
                        selected={this.state.endDate} isClearable={true}
                        onChange={this.handleChange2} showDisabledMonthNavigation />
                </div>
                <label className="float-left">{label['UserChangeLog.Transaction.To.Text'] !==undefined ? label['UserChangeLog.Transaction.To.Text'] : "To"}</label>
                    
                <div className="date_range_filter" style={{ width: '220px' }}>
                    <DatePicker style={{ "width": "20px" }} className="Form_Datepicker date_filter"
                        customInput={<DatePickerCustom />}
                        selected={this.state.startDate} isClearable={true}
                        onChange={this.handleChange} placeholderText="Click to select a date" />
                </div>
                <label className="float-left">{label['UserChangeLog.Transaction.From.Text'] !==undefined ? label['UserChangeLog.Transaction.From.Text'] :"From"}</label>
            </div>

            <div className="table_container tblScroll">
                <Table striped responsive className="Custom_table">
                    <tbody>
                        <tr>
                            <th>&nbsp;</th>
                            <th>&nbsp;</th>
                            <th>&nbsp;</th>
                        </tr>
                        {LogDetails}
                    </tbody>
                </Table>
            </div>
            <FormGroup row className="btns_group">
                <Col sm={{ size: 10 }} style={{"padding-left":"15px"}}>
                    <Button className="btn-black btn-md" onClick={this.BackToActionSettings} >{label['RegisterTESSiteLicense.lblBackToActionsAndSettings.Text'] !== undefined ? label['RegisterTESSiteLicense.lblBackToActionsAndSettings.Text'] : "< Action and Settings"}</Button>
                </Col>
            </FormGroup>
        </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        UserChangelog_List_Response: state.InstallationsRootReducer.UserChangeLogs,
        getLabels: state.CulturalLabelsRootReducer.SystemAdmin_LabelsBasedOnPreference
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetUserChangeLogDetails: (data) => dispatch(GetUserChangeLogDetails(data)),
        getAllResources: () => dispatch(getAllResources())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageUserChangeLog);

